import { Divider, Select } from "antd";
import Title from "antd/es/typography/Title";
import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { selectFiltering } from "shared/helpers";
import { Colors } from "shared/themes";
import { AdaptedValues, ExecuteReportValues } from "shared/types";

interface MultipleQualityFilteringProps {
  adaptedOrders: AdaptedValues[];
  selectedOrderId: number | null;
  onOrderChange: (value: number) => void;
  isLoadingOrders: boolean;
  clearPdfUrl?: () => void;
}

const MultipleQualityFiltering: FC<MultipleQualityFilteringProps> = ({
  adaptedOrders,
  selectedOrderId,
  onOrderChange,
  isLoadingOrders,
  clearPdfUrl,
}) => {
  const { t } = useTranslation("", { keyPrefix: "executeReports" });

  const { setFieldValue, values } = useFormikContext<ExecuteReportValues>();

  const expandOnOrderChange = (value: number) => {
    onOrderChange(value);
    setFieldValue("order_id", value);
  };

  const handleReportFormatChange = (format: string) => {
    setFieldValue("report_format", format);
    if (clearPdfUrl) {
      clearPdfUrl();
    }
  };

  const reportFormatOptions = [
    { label: "PDF", value: "pdf" },
    { label: "XLSX (Excel)", value: "xlsx" },
  ];

  return (
    <>
      <Divider className="my-1.5" style={{ background: Colors.blue.primary }} />

      <div className="flex gap-x-2">
        <Title level={5} className="!w-[100px] !m-0 !text-start">
          {t("selectOrder")}
        </Title>
        {" - "}
        <Select
          loading={isLoadingOrders}
          value={selectedOrderId}
          placeholder={t("selectOrder")}
          options={adaptedOrders}
          onChange={expandOnOrderChange}
          className="w-auto"
          size="small"
          showSearch
          filterOption={(input, option) => selectFiltering(input, option)}
        />
      </div>
      <Divider className="my-1.5" style={{ background: Colors.blue.primary }} />
      <div className="flex gap-x-2 items-center">
        <Title level={5} className="!w-[150px] !m-0 !text-start">
          Report Format
        </Title>
        {" - "}
        <Select
          value={values.report_format}
          placeholder="Select Report Format"
          options={reportFormatOptions}
          onChange={handleReportFormatChange}
          className="w-[300px]"
          size="small"
        />
      </div>
    </>
  );
};

export { MultipleQualityFiltering };
